import Service from '@/utils/fetch'
import { Toast } from 'antd-mobile'
import {
  CouponInfoModleList,
  ICouponParams,
  ICouponResponse,
  ProductItemType,
  RankList,
} from './typing'

export const getCouponDetail = async (
  params: ICouponParams,
  headers: any = {}
): Promise<ICouponResponse> => {
  const data = await Service.post({
    url: '/api/v1/h5/adapter/coupon/oversea/couponH5List',
    data: params,
    headers,
  })

  data.data.couponInfoModleList = data.data.couponTemplateList
  return data.data
}

// 获取用户身份
export const getUser = async (params, headers: any = {}) => {
  return Service.post({
    url: '/api/v1/h5/adapter/coupon/oversea/userIdentity',
    data: params,
    headers,
  })
}

// 领券接口 返回优惠券信息
// 状态：1可领；2 已领完；3 已领取。(ps:未登录，默认可领)
export const receiveCoupon = async (params, headers: any = {}): Promise<ICouponResponse> => {
  const data = await Service.post({
    url: '/api/v1/h5/adapter/coupon/oversea/drawCouponH5List',
    data: params,
    headers,
  })

  return data.data
}

// 下面2个接口榜单接口是因为是端上的接口，所以只能使用header作为数据传递；
// 榜单详情
export const getBooklistByType = async (
  body: any,
  headers: any = {}
): Promise<ProductItemType[]> => {
  const data = await Service.post({
    url: '/api/v1/h5/adapter/center/oversea/top/v1/list',
    data: body,
    headers: body,
  }).catch((e) => [])

  if (data.code !== 200) Toast.info('error')
  if (data.data) return data.data.spuList
  return []
}
// 获取3个榜单，只有一条数据，无法做展示
export const getHomeRank = async (body: any, headers: any = {}): Promise<RankList[]> => {
  const data = await Service.post({
    url: '/api/v1/h5/adapter/center/oversea/top/v1/homePage',
    data: body,
    headers: body,
  }).catch((e) => [])
  if (data.code !== 200) Toast.info('error')
  if (data.data) return data.data.topList

  return []
}
